<template>
  <v-app light>
    <AppBar/>
    <v-content>
      <role-switcher v-if="$auth.check() && isRoleSwitcherEnabled" />
      <router-view v-if="$auth.ready()" :key="$route.fullPath"/>
      <div v-if="!$auth.ready()">
        Loading ...
      </div>
    </v-content>
    <v-footer>
      <v-layout row>
        <v-flex xs6 text-xs-center text-md-center>
          <router-link to="/terms">{{ $vuetify.t('$vuetify.Footer.userTerms') }}</router-link>
        </v-flex>
        <v-flex xs6 xsmd2 text-xs-center text-md-center>
          <router-link to="/impressum">{{ $vuetify.t('$vuetify.Footer.impressum') }}</router-link>
        </v-flex>
      </v-layout>
    </v-footer>
  </v-app>
</template>

<script>
import Vue from 'vue'
import AppBar from './components/AppBar'

import './vison-font.css'
import RoleSwitcher from './components/RoleSwitcher'

export default {
  components: {RoleSwitcher, AppBar},
  data () {
    return {
      active: true,
      loading: true,
      cordova: Vue.cordova,
      clipped: false,
      drawer: true,
      title: 'Aula'
    }
  },
  computed: {
    isRoleSwitcherEnabled: function () {
      return this.$store.getters.schoolConfig.roleSwitcherEnabled
    }
  },
  beforeMount () {
    this.$root.$on('force-update', this.onForceUpdate)
  },
  created () {
    var self = this
    if (this.cordova) {
      this.cordova.on('deviceready', () => {
        self.onDeviceReady()
      })
    }
  },
  methods: {
    onForceUpdate: function () {
      this.$forceUpdate()
    },
    onDeviceReady: function () {
      // Handle the device ready event.
      this.cordova.on('pause', this.onPause, false)
      this.cordova.on('resume', this.onResume, false)
    },
    onPause () {
      // Handle the pause lifecycle event.
      console.log('pause')
    },
    onResume () {
      // Handle the resume lifecycle event.
      // SetTimeout required for iOS.
      setTimeout(function () {
        console.log('resume')
      }, 0)
    },
    onBackKeyDown () {
      // Handle the back-button event on Android. By default it will exit the app.
      navigator.app.exitApp()
    }
  }
}
</script>

<style>
:root {
  --var-border-radius: .2rem;
  --color-warning: #fdd75e;
  --color-sucess: #90e091;
}

body {
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
}

.boldfont, .headline {
  font-family: 'visionbold', Helvetica, Arial, sans-serif !important;
}

.theme--light.application {
  background-color: #eee;
  font-family: 'visionregular', Helvetica, Arial, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

footer { /* Apply this to v-bottom-nav if necessary. */
  margin-bottom: constant(safe-area-inset-bottom);
  margin-bottom: env(safe-area-inset-bottom);
}

.header_logo {
  width: 50px;
}

.v-progress-linear {
  margin: 0;
}
</style>
